window.csPdpFormatMoney =
  window.csPdpFormatMoney ||
  function csPdpFormatMoney(cents, moneyFormat) {
    const format = moneyFormat || '${{amount}}'
    const value = Number(cents) || 0

    const placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/)
    const placeholder = placeholderMatch ? placeholderMatch[1] : 'amount'

    const withDecimals = placeholder.indexOf('no_decimals') === -1
    const useComma = placeholder.indexOf('with_comma_separator') !== -1

    const amount = withDecimals ? (value / 100).toFixed(2) : Math.round(value / 100).toString()
    const parts = amount.split('.')
    const thousandsSeparator = useComma ? '.' : ','
    const decimalSeparator = useComma ? ',' : '.'
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator)
    const formatted = parts.length > 1 ? integerPart + decimalSeparator + parts[1] : integerPart

    return format.replace(/\{\{\s*\w+\s*\}\}/, formatted)
  }
